import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';

export const StyledSubscriptionTooltip= styled.div`
  position: relative;

  & button {
    --size: 1.8em;
    appearance: none;
    background: transparent;
    box-sizing: border-box;
    display: inline-block;
    border: 1px solid var(--black);
    border-radius: 50%;
    font-size: 12px;
    width: var(--size);
    height: var(--size);
    text-align: center;
    cursor: pointer;
    color: inherit;
    padding: 0;
  }

  & .tooltip {
    --color: var(--darkGray);
    padding: 45px 30px 30px;
    color: var(--color);
    border: 1px solid var(--color);
    border-radius: 20px;
    background: var(--white);
    width: 90vw;
    max-width: 250px;
    z-index: 20;

    & p {
      margin: 0;

      & + p {
        margin-top: 1em;
      }
    }

    & .close {
      position: absolute;
      top: 12px;
      right: 25px;
      font-size: 26px;
    }
  }

  @media (min-width: 768px) {
    & .tooltip {
      padding-top: 30px;

      & .close {
        display: none;
      }
    }
  }
`;
